module.exports = __webpack_public_path__ + "static/img/home_product2@2x.4e59491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productIntroduction/home_product2@2x.png
// module id = UB3s
// module chunks = 0